import request from '@/utils/request'

// 日程調整-カレンダー
export function calendarSure(data) {
  return request({
    url: `/api/works/top/calendar`,
    method: 'post',
    data,
  })
}
